import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Keeps the artwork label in step with the chosen variant. When a visitor picks a
 * print's material or size, the theme re-renders the section; the label then takes
 * its details and price rows from that new markup, as the price block does.
 */
class FifiArtworkLabelComponent extends Component {
  /** @type {Element | null} */
  #section = null;

  connectedCallback() {
    super.connectedCallback();
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#section = null;
  }

  /**
   * @param {Event & { promise?: Promise<{ detail?: { html?: Document | Element } }> }} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;

    event.promise
      .then(({ detail }) => {
        const fresh = detail?.html?.querySelector(`fifi-artwork-label-component[data-block-id="${this.dataset.blockId}"]`);
        if (!fresh || !this.isConnected) return;
        this.replaceChildren(...Array.from(fresh.cloneNode(true).childNodes));
      })
      .catch(() => {
        // The selection failed to load; the label keeps the last known values
      });
  };
}

if (!customElements.get('fifi-artwork-label-component')) {
  customElements.define('fifi-artwork-label-component', FifiArtworkLabelComponent);
}
